import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiActivityService } from 'app/services/api-activity.service';
import { Observable, tap } from 'rxjs';

@Injectable()
export class ApiActivityInterceptor implements HttpInterceptor {
  constructor(private apiActivityService: ApiActivityService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Notify before request starts
    this.apiActivityService.notifyActivity();

    return next.handle(req).pipe(
      tap({
        next: () => this.apiActivityService.notifyActivity(),
        error: () => this.apiActivityService.notifyActivity(),
      })
    );
  }
}
